import { useMemo } from 'react';
import { createAdriverCustom } from '../../utils/helpers/createAdriverCustom';
import { useTargetedBanner } from '.';
import { TargetedBannerIds, BooleanType } from '../../types';

export interface AdriverTargetingProps {
  leased?: string | boolean | null;
  rooms?: number | null | undefined;
  categoryId?: string | null | undefined;
  hasRepair?: BooleanType | boolean | null | string[] | string;
  cityName?: string | null | undefined;
  price?: number | null | undefined | string;
  hasBillOfSale?: boolean | null | undefined;
  hasMortgage?: boolean | null | undefined;
  shouldNotRunOnRouter?: boolean;
  shouldLoad?: boolean;
}

export const useAdriverTargeting = ({
  leased,
  rooms,
  categoryId,
  hasRepair,
  cityName,
  price,
  hasBillOfSale,
  hasMortgage,
  shouldNotRunOnRouter = false,
  shouldLoad = true
}: AdriverTargetingProps) => {
  const adriverCustom = useMemo(
    () =>
      createAdriverCustom({
        leased: typeof leased === 'boolean' ? leased.toString() : leased,
        rooms: rooms ?? undefined,
        categoryId: categoryId ?? undefined,
        hasRepair: (typeof hasRepair === 'boolean'
          ? (hasRepair.toString() as BooleanType)
          : hasRepair) as BooleanType | null | undefined,
        cityName: cityName ?? undefined,
        price: (price ?? undefined) as number | null | undefined,
        hasBillOfSale: hasBillOfSale ?? undefined,
        hasMortgage: hasMortgage ?? undefined
      }),
    [
      leased,
      rooms,
      categoryId,
      hasRepair,
      cityName,
      price,
      hasBillOfSale,
      hasMortgage
    ]
  );

  useTargetedBanner(
    TargetedBannerIds.bg,
    adriverCustom,
    shouldLoad,
    shouldNotRunOnRouter || false
  );
  useTargetedBanner(
    TargetedBannerIds.catfish,
    adriverCustom,
    shouldLoad,
    shouldNotRunOnRouter || false
  );
};
